import { TRANSPORT } from '../../service/enums.js';
import { EnumDescriptor } from '../enum/index.js';
import BaseField from './BaseField.js';
class EnumField extends BaseField {
    default;
    enum;
    enumData;
    constructor(data) {
        super({
            ...data,
            example: data.example ?? data.default ?? Object.values(data.enum)[0],
        });
        this.default = data.default;
        this.enum = data.enum;
        this.enumData = EnumDescriptor.load(data.enum);
        if (!this.enumData) {
            throw new Error('An enum has NOT been registered. Please register it using `registerEnum`.');
        }
        this.references = [this.enumData];
        this.proto.type = this.enumData.name;
    }
    getExample(transport) {
        return this.enumData.getExample(transport);
    }
    toSchema() {
        return {
            $ref: `#/components/schemas/${this.enumData.name}`,
            ...(this.default && { default: this.default }),
        };
    }
    toJSON(input, target) {
        if (target === TRANSPORT.GRPC) {
            return this.enumData.keyFromValue(input, target);
        }
        return input;
    }
    fromJSON(input) {
        if (input === undefined || typeof input !== 'string') {
            return undefined;
        }
        return input;
    }
    fromProto(input) {
        if (input === undefined || typeof input !== 'string') {
            return undefined;
        }
        return this.enumData.fromProto(input);
    }
}
export default EnumField;
//# sourceMappingURL=EnumField.js.map